/**
 * useServices Hook
 *
 * Provides access to the service registry from any component
 * within the ServiceProvider tree.
 *
 * @module hooks/useServices
 *
 * @example
 * ```tsx
 * const services = useServices();
 * // Access specific services (available after respective phase migrations):
 * // const { tradeService } = services;
 * ```
 */
import { useContext } from 'react';
import { ServiceContext } from '../contexts/ServiceContext';
import type { ServiceRegistry } from '../services/types';

/**
 * Hook to access all registered services.
 *
 * @returns The current ServiceRegistry from context
 */
export function useServices(): ServiceRegistry {
  return useContext(ServiceContext);
}
